<template>
  <div class="artical-detial">
    <div class="artical-title">
      <h2 class="ta_c">绿瘦训练营“上海基地”，你了解多少？</h2>
    </div>
    <div class="artical-body">
      <p>上海基地位于上海市闵行区绿瘦酒店内，属于绿瘦集团自建减肥训练基地，各项设备设施齐全。基地临近上海虹桥机场、虹桥站，交通便捷。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_a.jpg" alt="" class="img-css">

      <h3 class="ta_c">训练场地</h3>
      <p>基地配有大型操房、有氧力量器械区、动感单车房、瑜伽房、普拉提功能室等减肥运动场地，自带羽毛球场、游泳池等休闲娱乐场地。丰富的训练课程，给营员们提供多样化的运动体验。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_b.jpg" alt="">
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_c.jpg" alt="" class="img-css">
      
      <h3 class="ta_c">星级住宿</h3>
      <p>绿瘦集团自营星级酒店住宿客房，管家式服务，配套设施齐全，营员在营减肥期间居住环境安全舒适。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_d.jpg" alt="">
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_e.jpg" alt="" class="img-css">

      <h3 class="ta_c">营养餐饮</h3>
      <p>专业营养师依据中国居民膳食宝塔合理配比各类营养元素，饮食方面做到定时、定量、营养均衡，补充身体所需营养的同时辅助减脂。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_f.jpg" alt="">
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_g.jpg" alt="">
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_h.jpg" alt="">
      <p class="img-desc ta_c">（营地日常减脂餐）</p>
      <p>美味可口、营养均衡的家常菜，让您出营后也能学会合理配餐。 </p>

      <h3 class="ta_c">减脂课程</h3>
      <p>主要包括有氧训练、力量训练和舒缓拉伸等课程，减肥的同时提高身体肌肉含量和基础代谢，根据营员的需求塑造身体曲线。由资深教练带队训练，实时观察营员运动状况，预防运动损伤，帮助营员更好地减重。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_i.jpg" alt="">
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_j.jpg" alt="">
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_k.jpg" alt="" class="img-css">

      <h3 class="ta_c">晚间活动与户外拓展</h3>
      <p>封闭训练并非完全封闭，在营期间，训练营会因地制宜安排大小户外拓展训练，还会有丰富多样的晚间娱乐活动。告别枯燥，放松身心。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_l.jpg" alt="" class="img-css">
      
      <h3 class="ta_c">运动安全</h3>
      <p>训练营通过人体成分分析和4M体能测试数据，了解营员身体和运动情况，为营员制定个性化运动减肥方案。在健康合理范围内进行减重，并进行安全和效果监督，严格把控每日运动强度，避免运动损伤。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_tow_m.jpg" alt="" class="img-css">
      <p>绿瘦减肥训练营·上海基地，期待您的加入。 </p>
      

    </div>
  </div>
</template>
<script>

export default {
 
  name:'articalTow',
  data(){
    return{
      
    }
  },
  methods:{
    
  }
}
</script>
<style lang="less">
.img-css{
  padding-bottom: 22px;
}
</style>


